import angular from 'angular';

let PasswordChangeService = ($uibModal, UserResource, gettext, toastr, CMSAuthService) => {

    let service = {};

    service.open = () => {

        $uibModal.open({
            animation: true,
            template: require('./changePasswordModal.html'),
            size: 'md',
            controllerAs: 'vm',
            backdrop: 'static',
            keyboard: false,
            controller: ($uibModalInstance, toastr, $state, gettextCatalog) => {
                let vm = {};
                vm.password = '';
                vm.passwordRepeat = '';
                vm.error = '';
                vm.changePending = false;

                vm.change = () => {

                    vm.errors = {};

                    if(!vm.password) {
                        vm.errors = {plainPassword: [gettextCatalog.getString('This field cannot be empty.')]};
                        return;
                    }

                    if(vm.password && vm.password !== vm.passwordRepeat) {
                        vm.errors = {repeatPassword: [gettextCatalog.getString('The passwords are not identical.')]};
                        return;
                    }

                    vm.changePending = true;
                    let userId = CMSAuthService.getUser().id;
                    let request = {id: userId, plainPassword: vm.password};

                    UserResource.update(request, response => {
                        CMSAuthService.reLogin(vm.password).then(function () {
                                $uibModalInstance.close();

                                toastr.success(
                                    gettextCatalog.getString('Password has been changed'),
                                    gettextCatalog.getString('Success')
                                );
                                $state.go('dashboard');
                            }
                        );

                    }, error => {
                        vm.changePending = false;
                        vm.errors = error.data;
                    });

                };

                return vm;
            }
        });
    };

    return service;
};

/**
 * Service providing change password modal.
 * @namespace cms.password.change
 */
export default angular.module('cms.password.change', []).factory('PasswordChangeService', PasswordChangeService).name;


// WEBPACK FOOTER //
// ./src/cmsCore/ChangePasswordModal/changePassword.js